import { GetPerformanceResultsResponseBodyType } from "@intelligems/ig-types";
import { useQuery } from "@tanstack/react-query";

import { QueryOptions } from "../../types/react-query";
import { api } from "../api";
import { useGetOrg } from "../organizations/get-organization";
import { pluginPerformanceKeys } from "../queryKeys";

const getPerformanceResults = async () => {
  const resp = await api.get<GetPerformanceResultsResponseBodyType>(
    `/v2/organizations/plugin-performance`
  );
  return resp.data;
};

export const useGetPerformanceResults = (
  options?: QueryOptions<GetPerformanceResultsResponseBodyType, Error>
) => {
  const org = useGetOrg();
  return useQuery<GetPerformanceResultsResponseBodyType, Error>({
    ...options,
    queryKey: pluginPerformanceKeys.one(org.data.org.id),
    queryFn: async () => getPerformanceResults(),
    enabled: !!org.data.org.id,
  });
};
